import React, { useCallback, useState } from "react";
import PortalContext from "./PortalContext";
var PortalProvider = _ref => {
  var {
    children
  } = _ref;
  var [portals, setPortals] = useState([]);
  var deregisterPortal = useCallback(id => {
    setPortals(currentPortals => currentPortals.filter(portal => portal.id !== id));
  }, []);
  var registerPortal = useCallback(newPortal => {
    setPortals(currentPortals => [...currentPortals, newPortal]);
  }, []);
  return /*#__PURE__*/React.createElement(PortalContext.Provider, {
    value: {
      portals,
      registerPortal,
      deregisterPortal
    }
  }, children);
};
export default PortalProvider;